// Minimal first-party cookie consent store for the marketing site.
// Records the visitor's choice so that non-essential tags (analytics, marketing)
// are only ever loaded after an explicit opt in, per UK PECR / UK GDPR.
//
// The banner offers a single all-or-nothing choice (Accept all / Reject), so the
// stored record is simply { analytics, marketing }. Bumping VERSION invalidates
// old choices and re-shows the banner (use when the tracking inventory changes).
//
// Tracker: docs/plans/cookie-banner-implementation.md

const COOKIE_NAME = 'improve_consent';
const VERSION = 1;
const MAX_AGE_DAYS = 180;

function read() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
  if (!match) return null;
  try {
    const obj = JSON.parse(decodeURIComponent(match[1]));
    return obj && obj.v === VERSION ? obj : null;
  } catch (e) {
    return null;
  }
}

export function getConsent() {
  return read();
}

// True once the visitor has made any choice (so the banner should stay hidden).
export function hasResponded() {
  return read() !== null;
}

export function hasAnalytics() {
  const c = read();
  return !!(c && c.analytics);
}

export function hasMarketing() {
  const c = read();
  return !!(c && c.marketing);
}

export function setConsent({ analytics = false, marketing = false } = {}) {
  const value = JSON.stringify({
    v: VERSION,
    analytics: !!analytics,
    marketing: !!marketing,
    ts: Date.now(),
  });
  const maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
  // Add Secure on HTTPS (prod). Skip it on plain-http localhost dev, where Secure
  // would stop the cookie being stored at all.
  const secure =
    typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
  document.cookie =
    COOKIE_NAME + '=' + encodeURIComponent(value) +
    '; max-age=' + maxAge + '; path=/; SameSite=Lax' + secure;
}
